var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217.75 93.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#97a0f9;}.cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 2192") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.76,89.94a27.6,27.6,0,0,0,6.81-31.38C102.85,39,121.81,17.44,142.3,23.66A27.51,27.51,0,0,0,172.55,13C185.38-5.09,212.75.14,217,21.21a27,27,0,0,0,.76,2.84V16.59c-7.19-19.32-34-22.87-46.83-4.77h0a25.51,25.51,0,0,1-28,9.93C120.75,15,100.32,38.22,109.74,59.37a25.6,25.6,0,0,1-6.33,29.1,29.42,29.42,0,0,0-4.35,5h2.48A27.33,27.33,0,0,1,104.76,89.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.48,54.94l-5.73-1.2,5.73-1.19a7.59,7.59,0,0,0,5.87-5.87L55.54,41l1.2,5.73a7.59,7.59,0,0,0,5.87,5.87l5.73,1.19-5.73,1.2a7.59,7.59,0,0,0-5.87,5.87l-1.2,5.73-1.19-5.73A7.59,7.59,0,0,0,48.48,54.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.35,41.65,64,41l3.35-.69a4.44,4.44,0,0,0,3.42-3.43l.7-3.34.7,3.34a4.44,4.44,0,0,0,3.42,3.43l3.35.69-3.35.7a4.41,4.41,0,0,0-3.42,3.43l-.7,3.34-.7-3.34A4.43,4.43,0,0,0,67.35,41.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.22,36a.75.75,0,0,1,1.06,0l2.19,2.19a.75.75,0,0,1-1.06,1.06L.22,37A.75.75,0,0,1,.22,36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.21,41a.75.75,0,0,1,1.06,0l2.19,2.19a.75.75,0,0,1,0,1.06.77.77,0,0,1-1.07,0L5.21,42A.75.75,0,0,1,5.21,41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.47,41a.75.75,0,0,1,0,1.06L1.28,44.2A.75.75,0,0,1,.22,43.14L2.41,41A.75.75,0,0,1,3.47,41Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.47,36a.75.75,0,0,1,0,1.06L6.28,39.21a.77.77,0,0,1-1.07,0,.75.75,0,0,1,0-1.06L7.4,36A.75.75,0,0,1,8.47,36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.22,79.83a.75.75,0,0,1,1.06,0L18.47,82a.75.75,0,0,1-1.06,1.06l-2.19-2.19A.75.75,0,0,1,15.22,79.83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.21,84.82a.75.75,0,0,1,1.06,0L23.46,87a.75.75,0,0,1,0,1.06.77.77,0,0,1-1.07,0l-2.19-2.19A.75.75,0,0,1,20.21,84.82Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.47,84.82a.75.75,0,0,1,0,1.06l-2.19,2.19A.75.75,0,0,1,15.22,87l2.19-2.19A.75.75,0,0,1,18.47,84.82Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.47,79.83a.75.75,0,0,1,0,1.06l-2.19,2.19a.77.77,0,0,1-1.07,0,.75.75,0,0,1,0-1.06l2.19-2.19A.75.75,0,0,1,23.47,79.83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard);
export default __webpack_public_path__ + "static/media/artboard.892a8826.svg";
export { ForwardRef as ReactComponent };